/**
 * VipTierPrices — listens for `bab:price-loaded` events dispatched by
 * build-a-box-membership-component and populates price displays in the
 * tier cards section. Zero additional API calls.
 */

class VipTierPrices extends HTMLElement {
  #onPriceLoaded = (e) => {
    const { tierIndex, frequency, price, currency } = e.detail;
    const card = this.querySelector(`[data-tier-index="${tierIndex}"]`);
    if (!card) return;

    const fmt = (amount) =>
      new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: currency || 'USD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }).format(amount);

    if (frequency === 'monthly') {
      const priceEl = card.querySelector('[data-bab-monthly-price]');
      if (priceEl) priceEl.textContent = fmt(price);
    } else if (frequency === 'annual') {
      const annualPriceEl = card.querySelector('[data-bab-annual-price]');
      if (annualPriceEl) annualPriceEl.textContent = fmt(price);
      const detailEl = card.querySelector('[data-bab-annual-detail]');
      if (detailEl) detailEl.textContent = `${fmt(price)}/year with annual plan`;
    } else if (frequency === 'semi-monthly') {
      const semiMonthlyPriceEl = card.querySelector('[data-bab-semi-monthly-price]');
      if (semiMonthlyPriceEl) semiMonthlyPriceEl.textContent = fmt(price);
    }
  };

  connectedCallback() {
    document.addEventListener('bab:price-loaded', this.#onPriceLoaded);
  }

  disconnectedCallback() {
    document.removeEventListener('bab:price-loaded', this.#onPriceLoaded);
  }
}

if (!customElements.get('vip-tier-prices')) {
  customElements.define('vip-tier-prices', VipTierPrices);
}
